import { render } from "./Dashboard.vue?vue&type=template&id=76efed7a&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=76efed7a&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=76efed7a&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76efed7a"]])

export default __exports__